import React from "react";
import { neturalBlack, netural400, secondary500 } from "../../../constants/color";
import { formatDate, formatId } from "../../../utils/marketplaceHelpers";
import TransferOrderTypeChip from "./TransferOrderTypeChip";

const OrderInfoCard = ({ order, stripeChargeUrl }) => {
  if (!order) return null;

  return (
    <div
      style={{
        border: "1px solid #DADADA",
        borderRadius: "12px",
        padding: "20px",
        backgroundColor: "#ffffff",
      }}
    >
      <div
        style={{
          fontSize: "18px",
          fontWeight: "600",
          color: neturalBlack,
          marginBottom: "20px",
        }}
      >
        Order Information
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <span style={{ color: netural400, fontSize: "14px" }}>Order ID:</span>
          <span style={{ color: neturalBlack, fontSize: "14px", fontWeight: "500" }}>
            {formatId(order.orderId)}
          </span>
        </div>

        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span style={{ color: netural400, fontSize: "14px" }}>Type:</span>
          <TransferOrderTypeChip orderType={order.orderType} />
        </div>

        {order.paymentDate && (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ color: netural400, fontSize: "14px" }}>Payment:</span>
            <span style={{ color: neturalBlack, fontSize: "14px" }}>
              {formatDate(order.paymentDate)}
            </span>
          </div>
        )}

        {order.completedDate && (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ color: netural400, fontSize: "14px" }}>Completed:</span>
            <span style={{ color: neturalBlack, fontSize: "14px" }}>
              {formatDate(order.completedDate)}
            </span>
          </div>
        )}

        {order.stripeChargeId && (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ color: netural400, fontSize: "14px" }}>Charge ID:</span>
            <span style={{ color: neturalBlack, fontSize: "14px", fontFamily: "monospace" }}>
              {formatId(order.stripeChargeId)}
            </span>
          </div>
        )}

        {stripeChargeUrl && (
          <div style={{ marginTop: "12px" }}>
            <a
              href={stripeChargeUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
                color: secondary500,
                fontSize: "14px",
                textDecoration: "none",
                fontWeight: "500",
              }}
            >
              Open in Stripe →
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default OrderInfoCard;
